import styled from 'styled-components';

export const FooterContainer = styled.footer`
  background: #1f2937;
  color: white;
  padding: 60px 0 0;

  @media (max-width: 768px) {
    padding: 40px 0 0;
  }
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0 15px;
  }

  @media (max-width: 480px) {
    padding: 0 10px;
  }
`;

export const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 3rem;
  margin-bottom: 3rem;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const FooterSection = styled.div`
  h3 {
    color: #2563eb;
    margin-bottom: 1rem;
    font-size: 1.5rem;
  }

  h4 {
    color: #f9fafb;
    margin-bottom: 1rem;
    font-size: 1.25rem;
  }

  p {
    color: #d1d5db;
    line-height: 1.6;
    margin-bottom: 1rem;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    margin-bottom: 0.5rem;
  }

  a {
    color: #d1d5db;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: #2563eb;
    }
  }
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    transition: transform 0.3s ease;

    &:hover {
      transform: translateY(-2px);
    }
  }
`;

export const FacebookIcon = styled.svg`
  width: 40px;
  height: 40px;
  fill: #1877f2;
  transition: all 0.3s ease;

  &:hover {
    fill: #1565c0;
    transform: scale(1.1);
  }
`;

export const ContactInfo = styled.div`
  p {
    margin-bottom: 0.75rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    a {
      color: #2563eb;
      font-weight: 500;
    }
  }
`;

export const Schedule = styled.div`
  p {
    margin-bottom: 0.5rem;
    color: #d1d5db;

    strong {
      color: #10b981;
    }
  }
`;

export const FooterBottom = styled.div`
  border-top: 1px solid #374151;
  padding: 2rem 0;
`;

export const FooterBottomContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }

  p {
    color: #9ca3af;
    margin: 0;
  }
`;

export const BadgeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;
  }
`;

export const ANPCBadge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  a {
    display: inline-block;
    transition: transform 0.3s ease;

    &:hover {
      transform: translateY(-2px);
    }

    img {
      height: 40px;
      width: auto;
      opacity: 0.8;
      transition: opacity 0.3s ease;

      &:hover {
        opacity: 1;
      }
    }
  }
`;
